












import {Component, Prop, Vue} from 'vue-property-decorator';
import Hardware from '@/components/system/hardware/Hardware.vue';

@Component({components: {Hardware}})
export default class HardwareView extends Vue {
  @Prop({required: true}) selectedHardwareId!: number;

  editHardware(id: any) {
    this.$emit('editHardware', id);
  }

  deleteHardware(id: any) {
    this.$emit('deleteHardware', id);
  }

  updateHardware() {
    this.$emit('updateHardware');
  }

  updateData() {
    (this.$refs.hardware as any).setValues();
  }
}
